/* Meta Pixel + GoHighLevel external tracking — global, duplicate-safe. */
const META_PIXEL_ID = "1611990220389546";
const GHL_TRACKING_SRC = "https://link.msgsndr.com/js/external-tracking.js";
const GHL_TRACKING_ID = "tk_8a694cc5f38e4bda9cc1351b5aa86e62";

let lastPageViewKey = null;
let lastContactAt = 0;

export function initMetaPixel() {
  if (window.__ah_meta_init) return;
  window.__ah_meta_init = true;
  if (!window.fbq) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
  }
  window.fbq("init", META_PIXEL_ID);
}

export function initGhlTracking() {
  if (document.querySelector(`script[src="${GHL_TRACKING_SRC}"]`)) return;
  const s = document.createElement("script");
  s.src = GHL_TRACKING_SRC;
  s.setAttribute("data-tracking-id", GHL_TRACKING_ID);
  document.body.appendChild(s);
}

const fbq = (...args) => { try { window.fbq && window.fbq(...args); } catch { /* noop */ } };

export function trackMetaPageView(key) {
  if (key === lastPageViewKey) return;
  lastPageViewKey = key;
  fbq("track", "PageView");
}

export function trackContactClick() {
  const now = Date.now();
  if (now - lastContactAt < 3000) return;
  lastContactAt = now;
  fbq("track", "Contact");
}

export function trackReservationStarted() {
  try {
    if (sessionStorage.getItem("ah_res_started")) return;
    sessionStorage.setItem("ah_res_started", "1");
  } catch { /* noop */ }
  fbq("trackCustom", "ReservationStarted");
}

export function newLeadEventId() {
  try { return crypto.randomUUID(); }
  catch { return `${Date.now()}-${Math.random().toString(16).slice(2)}`; }
}

export function trackLead(eventId) {
  fbq("track", "Lead", {}, { eventID: eventId });
}

const cookie = (name) => {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : "";
  } catch { return ""; }
};

export function metaLeadFields() {
  return { meta_event_id: newLeadEventId(), meta_fbp: cookie("_fbp"), meta_fbc: cookie("_fbc") };
}
